import script from "./UpdateStatusPengajuan.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateStatusPengajuan.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateStatusPengajuan.vue?vue&type=style&index=0&id=134abae8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134abae8"]])

export default __exports__